<script lang="ts" setup>
import type { Component, SVGAttributes } from 'vue'

defineProps<{
  icon: Component<SVGAttributes>
}>()
</script>

<template>
  <button class="tw:group tw:cursor-pointer tw:p-4 tw:md:p-[0.3rem]">
    <component
      :is="icon"
      class="tw:block tw:opacity-50 tw:group-hover:opacity-100 tw:group-focus-visible:opacity-100"
    />
  </button>
</template>

<style scoped>
button {
  all: unset;
  outline: revert;
}
</style>
